var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_64044",
    "data-name": "Group 64044",
    transform: "translate(-588 -1086)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4088",
    "data-name": "Ellipse 4088",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(588 1086)",
    fill: "#00933b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72037",
    "data-name": "Path 72037",
    d: "M595.669,1100.29l2.893,2.912,6.439-6.535",
    transform: "translate(-1.203 -2.677)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickCircle);
export default __webpack_public_path__ + "static/media/green-tick-circle.f77c8991.svg";
export { ForwardRef as ReactComponent };